import httpClient from '@/utils/httpClient';
import { TAppSettings } from '@features/appSettings/types';

export const getAppSettingsQuery = () => {
  return httpClient<TAppSettings>({
    url: `/Setting/AppInfo`,
    method: 'get',
  });
};
